import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { IProps } from './SmallWindowWarningDialog';

export const renderSmallWindowWarningDialog = () => openPopupHelper<IProps>({ popupName: popupNames.SMALL_WINDOW_WARNING_DIALOG });
